import React, { FC, ReactElement, }  from "react";
import { classNames, parseClasses, } from ".";

interface Props {
    checked: boolean;
    label?: string;
    name?: string;
    className?: string | string[];
    readonly?: boolean;
    disabled?: boolean;
    showLabel?: boolean;

    onChange?: (e: React.FormEvent<HTMLInputElement>) => void;

    children?: React.ReactNode;
}

export const Checkbox: FC<Props> = (props): ReactElement => {
    const { checked, label, name, className, disabled, readonly, onChange, showLabel, } = props;

    const checkboxCss = classNames([
        "form-check-input",
        parseClasses(className),
        readonly ? "readonly" : null,
        disabled ? "disabled" : null,
        showLabel === false ? "mt-0" : null,
        showLabel === false ? "me-0" : "me-2",
        "__checkbox__",
    ]);

    const labelCss = classNames([
        showLabel === false ? "" : "form-label",
        "__checkboxlabel__"
    ]);

    return (
        <label className={labelCss}>
            <input
                type="checkbox"
                value={label}
                name={name}
                className={checkboxCss}
                defaultChecked={checked}
                disabled={disabled}
                readOnly={readonly}
                onChange={onChange}
                aria-label={label}
            />
            {showLabel !== false && <span>{label}</span>}
            {props.children}
        </label>
    );
}
